import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import * as memory from 'utils/memory';
import { NOTICE_BOARD } from 'constants/routes';
import { SEEN_NOTICE_IDS_KEY } from 'constants/memory';
import { useUserNotices } from 'hooks/query/useUserInfo';

export const useUnreadNoticeCount = (): number => {
  const notices = useUserNotices();
  const { pathname } = useLocation();

  const isNoticeBoard = pathname === NOTICE_BOARD;

  useEffect(() => {
    if (isNoticeBoard && notices?.length) {
      memory.set(
        SEEN_NOTICE_IDS_KEY,
        notices.map((n) => n.id)
      );
    }
  }, [isNoticeBoard, notices]);

  if (isNoticeBoard) {
    return 0;
  }

  const seenIds = new Set(memory.get(SEEN_NOTICE_IDS_KEY, true, []) as number[]);

  return notices?.filter((n) => !seenIds.has(n.id)).length ?? 0;
};
